import EntityServise from "./entityService";

class StageTypeService extends EntityServise{
    constructor() {
        super("stageType")
    }
}

export default new StageTypeService();